/** UNITED KINGDOM FORM **/

require('jqmask');

/*
  MOBILE NUMBER in UK have between 8 and 11 digits.
 */
$.validator.addMethod(
    'mobileValidation',
    (value, element) => {
      if ($(element).hasClass('required') === false) {
        return true;
      }

      if ((value === undefined) || (value === null) || (value === '')) {
        return false;
      }
/*
 Here we check there is between 8 and 11 numbers.
 Also we accept only 0 as the first digit
 */
      return (/^0[0-9]{7,10}$/).test(value);
    }
);


/* POSTCODES in UK have different formats using letters and digits.
 As all formats end with 9AA (where A signifies a letter and 9 a digit),
 the first part of a postcode can easily be extracted by ignoring the last three characters.
 */
$.validator.addMethod(
    'zipValidation',
    (value, element) => {
      if ($(element).hasClass('required') === false) {
        return true;
      }

      if ((value === undefined) || (value === null) || (value === '')) {
        return false;
      }

      /*
      TODO - official regexp :
      ^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$
       */
      const testResult = (/^[a-z][a-z0-9 ]*$/i).test(value);
/*
 Some crown dependencies (The Channel Islands) are not accepted :
 - GY : Guernsey
 - JE : Jersey
 */
      return testResult && !value.toUpperCase().startsWith('GY') && !value.toUpperCase().startsWith('JE');
    }
);

$(() => {
  // MOBILE NUMBER - Mask between 8 and 11 digits with 3 optionnal digit at the end. The first digit has to be a '0'
  $("[data-id='mobile']").mask('09999999?999', { placeholder: '' });
});


// SHIPPING FORM only
// TODO - add comments
$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if ((form !== undefined) && (form !== null) && (form.id === 'shipping')) {
    if ((OCMS.GlobalVars.Brand === 'occ') || (OCMS.GlobalVars.Brand === 'mel') || (OCMS.GlobalVars.Brand === 'erb') || (OCMS.GlobalVars.Brand === 'cdm')) {
      const UnitedKingdomSpecificMakeZipNotRequiredForIreland = (field, required) => {
        if (required === true) {
          form.zipContainer.show();

          if (field.hasClass('required') === false) {
            field.addClass('required');
          }

          if (field.hasClass('zipValidation') === false) {
            field.addClass('zipValidation');
          }
        } else {
          form.zipContainer.hide();

          field.removeClass('required');
          field.removeClass('zipValidation');
        }
      };

      const UnitedKingdomSpecificConfigureShippingMethod = (country) => {
        if ((OCMS.GlobalVars.Brand === 'mel') || (OCMS.GlobalVars.Brand === 'erb') || (OCMS.GlobalVars.Brand === 'cdm')) {
          const list = $("[data-id='shippingMethodList']");
          list.find('.rdblistShippingMethodStep3').hide();
          list.find('.rdblistShippingMethodStep3 input:radio').attr('checked', '');
          list.find('.rdblistShippingMethodStep3 input:radio').prop('checked', false);

          if (country === 'United Kingdom') {
            list.find(".rdblistShippingMethodStep3[data-title='UK Standard']").show();
            list.find(".rdblistShippingMethodStep3[data-title='UK Express']").show();
          } else {
            list.find(".rdblistShippingMethodStep3[data-title='Ireland Standard']").show();
          }

          list.find('.rdblistShippingMethodStep3 input:radio').trigger('change');

          OCMSBagStep3.EqualizeShippingMethods();
        }
      };

      UnitedKingdomSpecificConfigureShippingMethod(form.country());
      UnitedKingdomSpecificMakeZipNotRequiredForIreland(form.zipField, form.country() !== 'Ireland');


      form.countryField.on('change', () => {
        UnitedKingdomSpecificConfigureShippingMethod(form.country());
        UnitedKingdomSpecificMakeZipNotRequiredForIreland(form.zipField, form.country() !== 'Ireland');
      });
    }
  }
});



// WEBPACK FOOTER //
// ./js/countryForm/united-kingdom.form.js